export const ValidatorCollection = (data) => {
	const { name, description, image, nftTemplates: tmp } = data;
	const collection = { name, description, image, tmp };
	collection.tmp = collection.tmp.map((e) => {
		const {
			name,
			description,
			price,
			type,
			totalNFTs,
			image,
			startDate,
			endDate,
		} = e;
		return {
			name,
			description,
			price,
			type,
			totalNFTs,
			image,
			startDate,
			endDate,
		};
	});
	Object.keys(collection).forEach((e) => {
		if (e === "tmp") {
			let tmp_ = [];
			collection[e].forEach((el) => {
				Object.keys(el).forEach((el_) => {
					if (!(el[el_] === "" || el[el_] === undefined)) delete el[el_];
				});
				if (Object.keys(el).length !== 0) {
					tmp_.push(el);
				}
			});
			if (tmp_.length === 0) {
				delete collection[e];
			} else {
				collection[e] = tmp_;
			}
		} else {
			if (!(collection[e] === "" || collection[e] === undefined))
				delete collection[e];
		}
	});
	return collection;
};
